import { useCallback, useEffect, useState } from 'react';
import { stockyApi } from '../components/misc/StockyApi';

export function useUserFeatureFlags(authUser) {
  const [loading, setLoading] = useState(Boolean(authUser));
  const [hasLoaded, setHasLoaded] = useState(false);
  const [flags, setFlags] = useState({
    bulkPriceUpdateEnabled: false,
    packsEnabled: false,
    kitsEnabled: false,
    skuMigrationImportEnabled: false,
    publishInAnotherAccountEnabled: false,
    publishInAnotherAccountCopiesUsed: 0,
    publishInAnotherAccountFreeLimit: 5,
  });

  const refresh = useCallback(async () => {
    if (!authUser) {
      setFlags({
        bulkPriceUpdateEnabled: false,
        packsEnabled: false,
        kitsEnabled: false,
        skuMigrationImportEnabled: false,
        publishInAnotherAccountEnabled: false,
        publishInAnotherAccountCopiesUsed: 0,
        publishInAnotherAccountFreeLimit: 5,
      });
      setHasLoaded(false);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setHasLoaded(false);
      const response = await stockyApi.getUserMe(authUser);
      const data = response?.data || {};
      setFlags({
        bulkPriceUpdateEnabled: data.bulkPriceUpdateEnabled === true,
        packsEnabled: data.packsEnabled === true,
        kitsEnabled: data.kitsEnabled === true,
        skuMigrationImportEnabled: data.skuMigrationImportEnabled === true,
        publishInAnotherAccountEnabled: data.publishInAnotherAccountEnabled === true,
        publishInAnotherAccountCopiesUsed: Number(data.publishInAnotherAccountCopiesUsed || 0),
        publishInAnotherAccountFreeLimit: Number(data.publishInAnotherAccountFreeLimit ?? 5),
      });
      setHasLoaded(true);
    } catch (error) {
      console.error('Error fetching user feature flags:', error);
    } finally {
      setLoading(false);
    }
  }, [authUser]);

  useEffect(() => {
    let active = true;

    const load = async () => {
      if (!active) return;
      await refresh();
    };

    load();
    return () => {
      active = false;
    };
  }, [refresh]);

  return {
    loading: Boolean(authUser) && (loading || !hasLoaded),
    refresh,
    ...flags,
  };
}
